import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { SectionHeading } from './SectionHeading';
export function FAQ() {
  const {
    t
  } = useLanguage();
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="bg-white py-20 sm:py-24" data-id="element-108" data-mp="1cgb5h5c2s2bg">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16 lg:px-8" data-id="element-109" data-mp="2a179eoa8d30x">
        <SectionHeading kicker={t.faq.kicker} title={t.faq.title} subtitle={t.faq.subtitle} data-id="element-110" data-mp="254gsxzuik5ez" />

        <dl className="divide-y divide-navy/10 border-y border-navy/10" data-id="element-111" data-mp="202rh4hzgvnpu">
          {t.faq.items.map((item, index) => {
          const expanded = open === index;
          return <div key={item.q} data-id="element-112" data-mp="opys3ey29ddh" data-mpi={index}>
                <dt data-id="element-113" data-mp="oq77pelkiwsd">
                  <button type="button" onClick={() => setOpen(expanded ? null : index)} aria-expanded={expanded} className="flex w-full items-center justify-between gap-6 py-5 text-left" data-id="element-114" data-mp="omjdsec7o8d4">
                    <span className="font-display text-base font-bold text-navy sm:text-lg" data-id="element-115" data-mp="1pkqmfmaci8qd">
                      {item.q}
                    </span>
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-mist text-navy" data-id="element-116" data-mp="1fnm0nnkewfa3">
                      {expanded ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-117" data-mp="16nyxoxc1b1ex" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-118" data-mp="rz2ubdkxackn" />}
                    </span>
                  </button>
                </dt>
                <AnimatePresence initial={false} data-id="element-119" data-mp="wyfd9n8oazhy">
                  {expanded && <motion.dd initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-120" data-mp="iywjy0kitspp">
                      <p className="max-w-2xl pb-5 text-sm leading-relaxed text-ink/70" data-id="element-121" data-mp="2fwaka4cre2u0">{item.a}</p>
                    </motion.dd>}
                </AnimatePresence>
              </div>;
        })}
        </dl>
      </div>
    </section>;
}